import { $ } from '@situation/setdesign.util';
import { selectors } from '../group-tickets/constants';

const isSpanish = /^\/es(\/|$)/.test(window.location.pathname);

const defineSpanishMomentLocale = () => {
    if (!window.moment || window.moment.locales().includes('es')) {
        return;
    }

    // defineLocale also makes 'es' the active global locale
    window.moment.defineLocale('es', {
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],
        monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
    });
};

const renderLegendIfAvailable = () => {
    const bestAvailabilityElements = document.querySelectorAll('.tc-availability--best');
    const bestLegends = document.querySelectorAll('.calendar-legend__best');
    if (bestAvailabilityElements.length === 0) {
        bestLegends.forEach((el) => el.classList.add('d-none'));
    } else {
        bestLegends.forEach((el) => el.classList.remove('d-none'));
    }
};

$(document).one('TicketCalendar.init', (e, TicketCalendar, $on) => {
    if (isSpanish) {
        defineSpanishMomentLocale();
    }

    const useModal = !(document.querySelector(selectors.form) && document.querySelector(selectors.calendarModal));
    const isGroupTickets = document.querySelector(selectors.calendarModal);
    const calendarProviderLogo = isGroupTickets
        ? html`
                <span class="icon icon-groups-logo">
                    <svg><use xlink:href="#icon-321"></use></svg>
                </span>
            `
        : html`
                <span class="icon icon-calendar-logo">
                    <svg><use xlink:href="#icon-broadwaydirect"></use></svg>
                </span>
            `;
    const innerLegend = html`
        <div class="calendar-legend">
            <div class="calendar-legend__partner">${calendarProviderLogo}</div>
            <div class="calendar-legend__best">
                <span class="calendar-legend__best-text"
                    >${isSpanish ? 'Mejor Disponibilidad' : 'Best Availability'}</span
                >
                <span class="icon icon-use calendar-legend__best-icon">
                    <svg><use xlink:href="#icon-best"></use></svg>
                </span>
                <span class="icon icon-use calendar-legend__best-green-icon">
                    <svg><use xlink:href="#icon-green-diamond"></use></svg>
                </span>
            </div>
        </div>
    `;
    $on(TicketCalendar.FILTER_DEFAULTS, (defaults) => {
        defaults.update({
            // set to the $tc-theme-name sass variable
            theme: 'wicked-theme',
            'disable-default-analytics': true,
            'calendar-week-header': { headerFormat: 'ddd MMM D' },
            breakpoint: 992,
            fullcalendar: {
                headingClass: 'heading heading--medium text--primary',
                prevIcon: '<svg><use xlink:href="#icon-long-arrow"></use></svg>',
                nextIcon: '<svg><use xlink:href="#icon-long-arrow"></use></svg>',
                ...(isSpanish && { locale: 'es' }),
            },
            'month-carousel': { useModal, innerLegend },
            'month-carousel-compact': { innerLegend },
            'calendar-week': { legendHtml: innerLegend },
            'calendar-list': { legendHtml: innerLegend },
            'selected-date-performances': {
                eventTimeFormat: (event) => {
                    const icons = {
                        best: '<svg><use xlink:href="#icon-green-diamond"></use></svg>',
                        sold_out: '<svg><use xlink:href="#icon-x-circle"></use></svg>',
                    };
                    return [event.format('h:mmA'), icons[event.availability] || ''].filter(Boolean).join(' ');
                },
                buttonLinkTextOverride: 'Select Seats',
            },
        });

        try {
            TicketCalendar.components.update('calendar-week-header', {
                computed: {
                    headerText() {
                        return html`
                            <div class="tc-week__day-block">
                                <div class="tc-week__day-block__day">
                                    <div>${this.start.format('ddd')}</div>
                                </div>
                                <div class="tc-week__day-block__month">
                                    <div>${this.start.format('MMM')}</div>
                                    <div class="heading--medium">${this.start.format('D')}</div>
                                </div>
                            </div>
                        `;
                    },
                },
            });
        } catch (error) {
            console.error('Error updating calendar-week-header component definition:', error);
        }

        try {
            TicketCalendar.components.update('calendar-week', {
                template: html`
                    <div class="tc-week" :class="'tc-week--' + theme" data-gtm="calendar">
                        <div v-if="legendHtml" class="tc-week__legend" v-html="legendHtml" />
                        <div
                            class="tc-week__grid"
                            data-gtm="week"
                            v-for="(week, weekIndex) in chunkedDayData"
                            :key="'week-' + weekIndex">
                            <div class="tc-week__header-row">
                                <calendar-week-header
                                    v-for="day in week"
                                    :key="day.start.format()"
                                    :start="day.start"></calendar-week-header>
                            </div>
                            <div class="tc-week__events-row" :class="eventRowClass">
                                <calendar-week-events
                                    v-for="day in week"
                                    :key="day.start.format()"
                                    :events="day.events"
                                    :use-modal="useModal"
                                    @select-event="selectEvent"></calendar-week-events>
                            </div>
                            <div class="tc-week__background">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <modal :open.sync="modalOpened">
                            <selected-event :event="selectedEvent" @click-event="closeModal" />
                        </modal>
                    </div>
                `,
            });
        } catch (error) {
            console.error('Error updating calendar-week component definition:', error);
        }

        try {
            TicketCalendar.components.update('calendar-list-item', {
                template: html`
                    <a
                        class="tc-list__event"
                        :href="event.url"
                        :class="event.className"
                        target="_blank"
                        @click.prevent="onClick"
                        data-gtm="0">
                        <span class="tc-list__col tc-list__col--left">
                            <span class="tc-list__date text--large text--uppercase">
                                {{event.format('MMM D')}}
                            </span>
                        </span>
                        <span class="tc-list__col tc-list__col--right">
                            <span class="tc-list__day">{{event.format('ddd')}}</span>
                            <span class="tc-list__time">{{event.format(eventTimeFormat)}}</span>
                        </span>
                    </a>
                `,
            });
        } catch (error) {
            console.error('Error updating calendar-week component definition:', error);
        }
    });

    $on(['select-month', TicketCalendar.VUE_RENDERED], renderLegendIfAvailable);
});
